import { Box, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { COMMON_WEB_PATH } from '../../../constant';

// 根據維護日索引取得對應的星期字串
const getWeekDayString = (dayIndex) => {
  const weekDays = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
  ];
  return weekDays[dayIndex] || '';
};

/**
 * @description: 維護通知內容組件，根據傳入的維護列表顯示相關信息
 * @param {Array} maintenanceList - 包含維護信息的列表
 * @return {JSX.Element}
 */
const MaintenanceContent = ({ maintenanceList }) => {
  const { t } = useTranslation();

  if (!maintenanceList || maintenanceList.length === 0) {
    return (
      <Box className="w-full p-4 text-center">
        <Text>{t('announcement.no_maintenance')}</Text>
      </Box>
    );
  }

  return (
    <>
      <Text marginBottom={'0.2em'}>{t('announcement.maintenance_notice')}</Text>
      <Text fontWeight={'bold'} className="mb-1 text-sm">
        {t('announcement.maintenance_schedule')}
      </Text>
      <Box
        overflow={'scroll'}
        height={'100%'}
        paddingBottom={'6em'}
        display={'grid'}
        gridTemplateColumns={'repeat(2, 1fr)'}
        gap={2}
      >
        {maintenanceList.map((item) => (
          <Box
            key={item.platformEnum}
            border="2px solid #A4F0FF"
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Box
              backgroundColor={'#003249CC'}
              width={'100%'}
              borderBottom={'2px solid #A4F0FF'}
              display={'flex'}
              justifyContent={'center'}
              padding={'0.5em'}
            >
              <Box
                display={'flex'}
                alignItems={'center'}
                width={{ base: '2rem', md: '3rem' }}
                height={{ base: '2rem', md: '3rem' }}
              >
                <Image
                  src={`${COMMON_WEB_PATH}/ds88platformIcon/${item.platformEnum}.png`}
                  filter={'drop-shadow(0 0 2px gray)'}
                />
              </Box>
            </Box>
            <Box
              backgroundColor={'#011929'}
              padding={'0.5em'}
              width={'100%'}
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
            >
              <Text
                fontSize={{ base: '0.9em', sm: '1em' }}
              >{`${t(`announcement.${getWeekDayString(item.maintenance_day_of_week)}`)} ${t('announcement.routine_maintenance')}`}</Text>
              <Text fontWeight={'bold'} fontSize={{ base: '0.8em', sm: '1em' }}>
                {`${item.maintenanceStartTime} - ${item.maintenanceEndTime}`}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
};
export default MaintenanceContent;
